// in src/Dashboard.js
import * as React from 'react'
import { FC } from 'react'
import { Navigate } from 'react-router'
import { useAuthState, useGetIdentity, usePermissions } from 'react-admin'

import { AppLoadingView } from 'dash/AppLoadingView'

const CustomDashboard: FC = () => {
  const { isLoading: permissionsLoading, permissions } = usePermissions()
  const { isLoading: authLoading, authenticated } = useAuthState()
  const { isLoading: identityLoading, identity } = useGetIdentity()

  if (permissionsLoading || authLoading || identityLoading) return AppLoadingView

  if (!authenticated) return <Navigate to="/login" />
  if (permissions.includes('admin')) return <Navigate to="/admin" />
  return <Navigate to={`/account/${identity.account.id}/services/form`} />
}

export default CustomDashboard
